export const initialState = {
  notifications: [],
  nextTokens: { 1: null },
  loading: false,
  error: null,
  nextToken: null,
  localNotifications: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_NOTIFICATION":
      return {
        ...state,
        notifications: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        loading: true,
        error: null,
      };
    case "LIST_NOTIFICATION_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        notifications: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_NOTIFICATION_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "UPDATE_NOTIFICATION_SUCCESS":
      const updatedNotifications = state.notifications.map((notification) => {
        if (notification.id === action.payload.notification.id) {
          return action.payload.notification;
        }
        return notification;
      });
      return {
        ...state,
        notifications: updatedNotifications,
      };
    case "ADD_LOCAL_NOTIFICATION":
      let existingNotifications = state.localNotifications;
      if (existingNotifications.length > 0) {
        existingNotifications = existingNotifications.filter(
          (notification) => notification.id !== action.payload.id
        );
      }
      if (existingNotifications.length >= 5) {
        existingNotifications = existingNotifications.slice(1);
      }
      return {
        ...state,
        localNotifications: [action.payload, ...existingNotifications],
      };
    case "REMOVE_LOCAL_NOTIFICATION":
      return {
        ...state,
        localNotifications: state.localNotifications.filter(
          (notification) => notification.id !== action.payload.id
        ),
      };
    default:
      return state;
  }
};
